import CombinedSearchComponent from './combined-search-component'
import CombinedSearchService from './combined-service'

/***
 * The typeahead that searches for clients/locations/facilities based on site id
 */
const combinedSearch = angular
    .module('FacilityData.ClientEdit.CombinedSearch', [])
    .component('combinedSearch', CombinedSearchComponent)
    .service('CombinedSearchService', CombinedSearchService)
    .name;

export default combinedSearch;


// WEBPACK FOOTER //
// ./app/components/client-admin/combined-search/combined-search.js